export default __webpack_public_path__ + "eb39ec4a70806884ba5d268832cb335c.svg";